
        import 'Dashboard.d787cb6.css-module'
        export default {"Dashboard":"Dashboard_Dashboard_d787cb6"}
    